<template>
  <a-card :title="title">
    <a-form-model ref="ruleForm" labelAlign="left" :model="form" :rules="rules" :label-col="{span: 6}" :wrapper-col="{span: 14}">
      <a-divider orientation="left">发布平台</a-divider>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="发布平台" prop="line_id">
            <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择" @change="changePlatform">
              <a-select-option v-for="item in line_idPlatformList.length?line_idPlatformList: platformList" :key="item.id" :value="item.id">
                <a-tooltip placement="topLeft" :title="item.org" arrow-point-at-center>
                  {{ item.org }}
                </a-tooltip>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="文章分类" prop="typeid">
            <a-select v-model="form.typeid" allowClear show-search option-filter-prop="children" placeholder="请选择">
              <a-select-option v-for="item in classifyList" :key="item.id" :value="item.id">
                <a-tooltip placement="topLeft" :title="item.path_name" arrow-point-at-center>
                  {{ item.path_name }}
                </a-tooltip>
              </a-select-option>
            </a-select>
            <!-- <a-cascader :options="classifyList" change-on-select :fieldNames="{ label: 'type_name', value: 'id', children: 'children' }" placeholder="请选择" @change="typeChange" /> -->
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="发布者" prop="publisher_id">
            <a-select v-model="form.publisher_id" allowClear show-search option-filter-prop="children" placeholder="请选择">
              <a-select-option v-for="item in authorList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="文章标签" :label-col="{span: 3}" :wrapper-col="{span: 19}" prop="label_ids">
            <!-- <a-select v-model.trim="form.label_ids" mode="multiple" allowClear show-search option-filter-prop="children" placeholder="请输入"> -->
            <div class="flex">
              <a-select v-model.trim="form.label_ids" mode="multiple" allowClear show-search :show-arrow="false" :filter-option="false" :not-found-content="[]" @search="handleLabelsSelectSearch" @change="handleLabelsSelectChange" placeholder="请输入" :maxTagTextLength="50">
                <a-select-option v-for="item in labelList" :key="item.id" :value="Number(item.id)">{{ `${item.label_name}(${item.org})` }}</a-select-option>
              </a-select>
              <a-button v-show="line_id" type="primary" style="margin-left: 15px;float:right;" @click="handleAddTag">新增标签</a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col v-if="!isEdit" :span="8">
          <a-form-model-item label="随机阅读数" prop="is_rand">
            <a-radio-group v-model="form.is_rand">
              <a-radio :value="0">否</a-radio>
              <a-radio :value="1">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="是否置顶" prop="istop">
            <a-radio-group v-model="form.istop">
              <a-radio v-for="item in ARTICLE_IS_TOP" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="是否推荐" prop="iscommend">
            <a-radio-group v-model="form.iscommend">
              <a-radio v-for="item in ARTICLE_ISCOMMEND" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-divider orientation="left">文章内容</a-divider>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="标题" prop="title" :label-col="{span: 3}" :wrapper-col="{span: 18}">
            <div class="flex">
              <a-input v-model="form.title" placeholder="请输入" :maxLength="80" />
              <a-button type="primary" class="btn-color-warning" style="margin-left: 15px" @click="forbiddenWords('title')">敏感词检测</a-button>
            </div>
            <div v-if="titleHtml" v-html="titleHtml"></div>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="小标题" prop="title2">
            <a-input v-model.trim="form.title2" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="作者" prop="author" :label-col="{span: 3}" :wrapper-col="{span: 18}">
            <a-input v-model.trim="form.author" placeholder="请输入" :maxLength="30" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="关键词" prop="keywords">
            <a-input v-model.trim="form.keywords" placeholder="请输入" style="width:70%; margin-right: 20px;"/>
            <a-button type="primary" @click="getTags">获取推荐标签</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="摘要" prop="description" :label-col="{span: 3}" :wrapper-col="{span: 18}">
            <a-input v-model.trim="form.description" type="textarea" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="推荐标签" prop="description">
            <div class="tags-swapper">
              <a-checkable-tag v-model="tag.checked" v-for="(tag, tagI) in tagList" :key="tagI" style="marign: 0px 3px;" @change="(isCheck)=>chooseOneTag(isCheck, tag)">{{ tag.label_name }}</a-checkable-tag>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="8">
          <a-form-model-item label="文章图片">
            <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="smetaList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'smeta')" list-type="picture-card" @preview="handlePreview" @change="(data) => handleChange('smeta', data)">
              <div v-if="smetaList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  Upload
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item label="缩略图">
            <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="thumbimageList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'thumbimage')" list-type="picture-card" @preview="handlePreview" @change="($event) => handleChange('thumbimage', $event)">
              <div v-if="thumbimageList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  Upload
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col span="8">
          <a-form-model-item label="banner图">
            <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="bannerList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'banner')" list-type="picture-card" @preview="handlePreview" @change="($event) => handleChange('banner', $event)">
              <div v-if="bannerList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  Upload
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 图片 -->
      <a-row>
        <a-col span="24">
          <a-form-model-item labelAlign="left" label="鱼爪app咨询列表图片" :label-col="{span: 2}" :wrapper-col="{span: 18}">
            <ul class="flex-sb">
              <li class="flex">
                <div class="flex-col-t">
                  <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="app_picture_oneList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'app_picture_one')" list-type="picture-card" @preview="handlePreview" @change="(data) => handleChange('app_picture_one', data)">
                    <div v-if="app_picture_oneList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">
                        Upload
                      </div>
                    </div>
                  </a-upload>
                  <a-button @click="handleTailor('app_picture_one')">裁剪</a-button>
                </div>
                <div class="flex-col-t">
                  <PreImg v-if="form.app_picture_cut_one" :src="`${QI_NIU_DOMAINS}/${form.app_picture_cut_one}`" @delete="hadnleDeleteCut('app_picture_cut_one')" />
                  <div v-else class="img-default">
                    <a-icon type="picture" />
                  </div>
                  <span style="margin-top: 10px">裁剪后</span>
                </div>
              </li>
              <li class="flex">
                <div class="flex-col-t">
                  <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="app_picture_twoList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'app_picture_two')" list-type="picture-card" @preview="handlePreview" @change="(data) => handleChange('app_picture_two', data)">
                    <div v-if="app_picture_twoList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">
                        Upload
                      </div>
                    </div>
                  </a-upload>
                  <a-button @click="handleTailor('app_picture_two')">裁剪</a-button>
                </div>
                <div class="flex-col-t">
                  <PreImg v-if="form.app_picture_cut_two" :src="`${QI_NIU_DOMAINS}/${form.app_picture_cut_two}`" @delete="hadnleDeleteCut('app_picture_cut_two')" />
                  <div v-else class="img-default">
                    <a-icon type="picture" />
                  </div>
                  <span style="margin-top: 10px">裁剪后</span>
                </div>
              </li>
              <li class="flex">
                <div class="flex-col-t">
                  <a-upload accept=".jpg, .jpeg, .png" :headers="{ token }" :file-list="app_picture_threeList" :action="`${baseURL}/public/upload-file-qi-niu`" :beforeUpload="(file) => handleBeforeUpload(file, 'app_picture_three')" list-type="picture-card" @preview="handlePreview" @change="(data) => handleChange('app_picture_three', data)">
                    <div v-if="app_picture_threeList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">
                        Upload
                      </div>
                    </div>
                  </a-upload>
                  <a-button @click="handleTailor('app_picture_three')">裁剪</a-button>
                </div>
                <div class="flex-col-t">
                  <PreImg v-if="form.app_picture_cut_three" :src="`${QI_NIU_DOMAINS}/${form.app_picture_cut_three}`" @delete="hadnleDeleteCut('app_picture_cut_three')" />
                  <div v-else class="img-default">
                    <a-icon type="picture" />
                  </div>
                  <span style="margin-top: 10px">裁剪后</span>
                </div>
              </li>
            </ul>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 文章内容 -->
      <a-row>
        <a-col span="24">
          <a-form-model-item label="内容" labelAlign="left" prop="content" :label-col="{span: 1}" :wrapper-col="{span: 20}">
            <div class="flex">
              <Editor v-model="form.content" style="width: 900px" />
              <div class="ml20">
                <a-button class="btn-color-warning" type="primary" @click="forbiddenWords('content')">敏感词检测</a-button> <br />
                <a-button class="btn-color-warning" type="primary" @click="previewPcFn">PC 预览</a-button> <br />
                <a-button class="btn-color-warning" type="primary" @click="previewWapFn">移动预览</a-button>
              </div>
            </div>
            <div v-if="contentHtml" v-html="contentHtml"></div>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :wrapper-col="{span: 20, offset: 1}">
            <a-button :loading="submitLoading" class="mr20" type="primary" @click="handleSubmit">{{ $route.query.status === '2' ? '提交审核': '保 存' }}</a-button>
            <a-button @click="$router.push('/article/list')">取 消</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <!-- PC 内容预览 -->
    <a-modal :width="1200" :destroyOnClose="true" :visible="previewPc" :footer="null" @cancel="previewPc = false">
      <div class="pc-container">
        <div v-html="form.content"></div>
      </div>
    </a-modal>

    <!-- wap 内容预览 -->
    <a-modal :width="423" :destroyOnClose="true" :visible="previewMobile" :footer="null" @cancel="previewMobile = false">
      <div class="wap-container">
        <iframe v-if="appDetailUrl" :src="appDetailUrl" style="width: 100%;height: 100%;"></iframe>
        <div v-else class="preViewWap" v-html="form.content"></div>
      </div>
    </a-modal>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <!-- 图片裁剪 -->
    <a-modal width="50%" title="图片裁剪" :destroyOnClose="true" :visible="cropperVisible" :footer="null" @cancel="cropperVisible = false">
      <CropperImg :init-img="tailorImg" @handleTailorOver="handleTailorOver" />
    </a-modal>
    <AddTag ref="tagVisible" @getLable="getLable" />
  </a-card>
</template>
<script>
import Editor from '@/components/Editor1/Editor.vue'
import AddTag from '@/components/Editor1/addTag'
import CropperImg from './components/Cropper/'
import { reactive, onMounted, toRefs, computed, watch, getCurrentInstance, ref } from '@vue/composition-api'
import { form, rules } from './business/constant'
import initList from './composables/initList'
import uploadImg from './composables/uploadImg'
import PreImg from '@/components/PreImg/'
import token from '@/composables/token'
import compuedFun from './computed/'
import api from '@/api/'
import BetterScroll from 'better-scroll'
import { async } from 'q'
// import func from 'vue-editor-bridge'

const title = {
  Add: '添加平台',
  Edit: '编辑平台'
}

export default {
  name: 'ArticleEdit',
  components: {
    PreImg,
    Editor,
    AddTag,
    CropperImg
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const isEdit = computed(() => !!_this.$route.params.id)
    const articleID = computed(() => _this.$route.params.id)
    const lineId = computed(() => _this.$route.query.line_id)

    const state = reactive({
      form: { ...form },
      rules,
      baseURL: process.env.VUE_APP_API_BASE_URL,
      title: title.Add,
      previewPc: false,
      previewMobile: false,
      titleHtml: '',
      contentHtml: '',
      appDetailUrl: '',
      submitLoading: false,
      line_idPlatformList: [],
      labelList: [], // 标签列表
      timer: null,
      line_id: lineId.value,
      tagList: [],
      // hasChoosedLabel: [],
    })

    watch(
      () => state.form.title,
      () => {
        if (state.form.title === '') {
          _this.titleHtml = ''
        }
      }
    )

    watch(
      () => state.form.content,
      () => {
        if (state.form.content === '') {
          _this.contentHtml = ''
        }
      }
    )

    const tagVisible = ref(null)
    onMounted(() => {
      const id = articleID.value
      const line_id = lineId.value
      _this.form.label_ids = []
      if (id) {
        state.title = title.Edit
        getArticleDetail()
      } else if (line_id) {
        _this.form.line_id = Number(line_id)
        getPlatformList(line_id)
      }
    })

    // 获取新增标签
    async function getLable(data) {
      await getLabelArticle({ label_name: data.label_name })
      state.form.label_ids.push(data.id)
      _this.$refs.ruleForm.validateField('label_ids', async valid => {})
    }
    // 显示新增标签表单
    function handleAddTag() {
      tagVisible.value.changeV()
    }

    // 获取平台列表
    async function getPlatformList(line_id) {
      const res = await api.LineListNew()
      const options = res.data
      const b = options.find(item => item.id === Number(line_id))
      state.line_idPlatformList.push(b)
      getDepartment(options, parseInt(b.id))
    }
    // 过滤平台列表
    function getDepartment(options, line_id) {
      options.forEach(item => {
        if (item.parent_id === line_id) {
          state.line_idPlatformList.push(item)
          getDepartment(options, parseInt(item.id))
        }
      })
    }

    function previewPcFn() {
      _this.checkRule('pc')
      // state.previewPc = true
      // _this.startScroll('pc-container')
    }

    function previewWapFn() {
      _this.checkRule('wap')
      // state.previewMobile = true
      // _this.startScroll('wap-container')
    }

    function checkRule(type) {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let res
          if (articleID.value) {
            const data = JSON.parse(JSON.stringify(state.form))
            data.label_ids = data.label_ids.join(',')
            res = await api.updateArticle(data)
          } else {
            const data = JSON.parse(JSON.stringify(state.form))
            data.label_ids = data.label_ids.join(',')
            res = await api.createArticle(data)
          }
          if (_this.$validate(res)) {
            if (type === 'pc') {
              if (res.data.data.pc_detail_url) {
                window.open(res.data.data.pc_detail_url)
              } else {
                state.previewPc = true
                _this.startScroll('pc-container')
              }
              if (!isEdit.value) {
                const id = res.data.id
                this.$router.push(`/article/edit/${id}`)
              }
            } else if (type === 'wap') {
              state.previewMobile = true
              _this.startScroll('wap-container')
              if (res.data.data.app_detail_url) {
                state.appDetailUrl = res.data.data.app_detail_url
              }
            }
          }
        } else {
          this.$message.warning('请检查信息是否填写完成')
        }
      })
    }

    function typeChange(e) {
      if (e.length) {
        _this.form.typeid = e[e.length - 1]
      } else {
        _this.form.typeid = ''
      }
    }

    function changePlatform(e) {
      _this.form.label_ids = []
      _this.labelList = []
    }

    async function forbiddenWords(type) {
      if (type === 'title') {
        if (!state.form.title) return _this.$message.warning('内容为空')
        const res = await api.forbiddenWordsArticle({ content: state.form.title, module: 1 })
        if (_this.$validate(res)) {
          if (/#F00/g.test(res.data.content)) {
            _this.$message.warning('存在为违禁词')
            _this.titleHtml = res.data.content
          } else {
            _this.titleHtml = ''
          }
        }
      }
      if (type === 'content') {
        if (!state.form.content) return _this.$message.warning('内容为空')
        const res = await api.forbiddenWordsArticle({ content: state.form.content, module: 1 })
        if (_this.$validate(res)) {
          if (/#F00/g.test(res.data.content)) {
            _this.$message.warning('存在为违禁词')
            _this.contentHtml = res.data.content
          } else {
            _this.contentHtml = ''
          }
        }
      }
    }

    // 启动滚动
    function startScroll(dom) {
      const wap = _this.$refs.wap
      _this.$nextTick(() => {
        if (BetterScroll) {
            new BetterScroll('.' + dom, {})
        }
        //   let wrapper = document.getElementById("wrapper")
        //   let bs = BetterScroll.createBScroll(wrapper, {})
      })
    }

    async function getArticleDetail() {
      const res = await api.detailArticle({ id: articleID.value })
      const data = res.data.article
      state.form = { ...data, label_ids: data.label_ids ? data.label_ids : [] }
      state.form.publisher_id = Number(state.form?.publisher_id) || undefined
      _this.labelList = data.label.map(item => ({ ...item, id: Number(item.id) })) || []
      _this.handleEchoImg(state.form)
      // 获取推荐标签列表
      if (state.form.keywords) {
        await _this.getTags()
        // 被选中的推荐标签
        _this.tagList.forEach(tag => {
          if (state.form.label_ids.includes(Number(tag.id))) {
            tag.checked = true
          }
        })
      }
    }

    // 获取标签（新）
    async function getLabelArticle(data = {}) {
      data = Object.assign({}, data, {
        status: 1,
        line_id: state.form.line_id ? state.form.line_id : lineId.value,
        page: 1,
        per_page: 100
      })
      const res = await api.labelSearch(data)
      _this.labelList = res.data.label || []
    }

    function handleLabelsSelectSearch(value) {
      if (state.timer) {
        clearTimeout(state.timer)
        state.timer = null
      }
      state.timer = setTimeout(() => {
        getLabelArticle({ label_name: value })
      }, 500)
    }

    function handleLabelsSelectChange(value) {
      if (value.length) {
        this.form.label_ids = value
      } else {
        getLabelArticle()
      }
      _this.$refs.ruleForm.validateField('label_ids', async valid => {})
    }

    async function handleSubmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          const arr = await Promise.all([
            api.forbiddenWordsArticle({ content: state.form.title, module: 1 }),
            api.forbiddenWordsArticle({ content: state.form.content, module: 1 })
          ])
          if (/#F00/g.test(arr[0].data.content) || /#F00/g.test(arr[1].data.content)) {
            _this.$confirm({
              content: '存在为违禁词,请确认是否提交？',
              async onOk() {
                _this.submit()
              }
            })
          } else {
            _this.submit()
          }
        } else {
          this.$message.warning('请检查信息是否填写完成')
        }
      })
    }

    async function submit() {
      let res
      this.submitLoading = true
      if (articleID.value) {
        state.form.publisher_id = state.form.publisher_id || 0
        const data = JSON.parse(JSON.stringify(state.form))
        data.label_ids = data.label_ids.join(',')
        res = await api.updateArticle(data)
      } else {
        state.form.publisher_id = state.form.publisher_id || 0
        const data = JSON.parse(JSON.stringify(state.form))
        data.label_ids = data.label_ids.join(',')
        res = await api.createArticle(data)
      }
      this.submitLoading = false
      if (_this.$validate(res)) {
        this.$message.success(articleID.value ? '编辑成功~' : '添加成功~')
        this.$router.push('/article/list')
      }
    }

    async function getTags() {
      if (!this.form.keywords) return this.$message.warning('请先填写关键词')
      const { data } = await api.labelSearch({
        status: 1,
        line_id: this.form.line_id,
        is_no_business_child: 1, // 是否不包含子类目数据 默人包含  传1不包含
        label_name: this.form.keywords,
        page: 1,
        per_page: 510
      })
      const resData = data ? data.label || [] : []
      if (!resData.length) this.$message.warning('没有相关数据')
      this.tagList = resData.map(item => {
        item.checked = false
        return item
      })
    }

    async function chooseOneTag(isCheck, tag) {
      await getLabelArticle({ label_name: tag.label_name })
      const tagId = this.labelList[0]?.id
      if (isCheck) {
        if (tagId && !this.form.label_ids.includes(tagId)) {
          this.form.label_ids = [...this.form.label_ids, tagId]
        }
      } else {
        this.form.label_ids = this.form.label_ids.filter(item => String(item) !== String(tagId))
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...initList(),
      ...uploadImg(),
      ...token(),
      isEdit,
      articleID,
      getLable,
      tagVisible,
      forbiddenWords,
      handleAddTag,
      changePlatform,
      getArticleDetail,
      handleSubmit,
      startScroll,
      typeChange,
      submit,
      previewPcFn,
      previewWapFn,
      checkRule,
      handleLabelsSelectSearch,
      handleLabelsSelectChange,
      getTags,
      chooseOneTag
    }
  }
}
</script>

<style lang="less" scoped>
.tailor-img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.img-default {
  width: 100px;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-preview {
  background-color: orange;
  position: fixed;
  width: 100%;
  height: 100%;
}

.tags-swapper{
  max-height: 200px;
  min-height: 40px;
  overflow-y: auto;
  border: 2px solid #eee;
  padding: 3px 5px;
  border-radius: 5px;
  /deep/.ant-tag{
    margin-right: 5px !important;
    border: 1px solid #d9d9d9;
  }
}
</style>

<style lang="less">
.pc-container {
  width: 100%;
  height: 700px;
  overflow-y: auto;
  /deep/img {
    width: 100%;
    height: auto;
  }
}
.wap-container {
  width: 375px;
  height: 667px;
  overflow-y: auto;
}
.preViewWap {
  /deep/img {
    width: 100%;
    height: auto;
  }
}

</style>
